module.exports = ".container {\n    height: 100vh;\n    background: lightblue;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;    \n    -webkit-box-pack: center;    \n        -ms-flex-pack: center;    \n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n\n.center {\n    text-align: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/countdown/countdown.component.css
// module id = ./src/app/components/dashboard/countdown/countdown.component.css
// module chunks = main